/* Mesmerize · Tungsten PDP · mes-comfort-cutaway.js (loaded deferred by sections/mes-pdp3-comfort.liquid only)
   Port of the Website 3.0 design's cutaway-anim.js: full ring -> wedge cut away -> zoom onto the cut face with the inner
   profile highlighted. One card is the flat inside ("most rings"), the other the domed inside.
   Each card shows its POSTER image first. The three.js bundle (assets/mes-three-ring.min.js, shared with the 3D ring
   viewer, one load for both cards) is fetched only when the section comes within 300px of the screen; each card then
   draws its first frame over the poster and plays ONCE when it is 60% visible. When the animation ends the last frame is
   copied into a plain 2D canvas and the WebGL renderer is disposed, so no WebGL context stays alive.
   Still (poster only, nothing loaded): mode "off", mode "lowend" on weak devices, reduced motion, window.MES_SLOW.
   A card with no poster in still mode draws its LAST frame once instead (one short WebGL use, then disposed). */
(function () {
  'use strict';
  if (window.__mesComfortCut) return; window.__mesComfortCut = true;

  /* Same low-end test as assets/mes-five-worlds.js. */
  function lowEnd() {
    var n = navigator, c = n.connection || {};
    return (n.deviceMemory > 0 && n.deviceMemory <= 4) || (n.hardwareConcurrency > 0 && n.hardwareConcurrency <= 4) || c.saveData === true;
  }
  function mq(q) { try { return matchMedia(q).matches; } catch (e) { return false; } }
  function three(url) {
    if (!window.__mesThreeRing) window.__mesThreeRing = window.__mesImport(url).catch(function (e) { window.__mesThreeRing = null; throw e; });
    return window.__mesThreeRing;
  }
  var ease = function (t) { return t < 0 ? 0 : t > 1 ? 1 : t * t * (3 - 2 * t); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  /* Build one card's scene (verbatim geometry and camera path from cutaway-anim.js). */
  function Cut(T, box, domed, col, dpr) {
    var W = box.clientWidth || 300, H = box.clientHeight || 195;
    var r = this.r = new T.WebGLRenderer({ antialias: true, alpha: true });
    r.setPixelRatio(dpr); r.setSize(W, H, false);
    r.outputColorSpace = T.SRGBColorSpace; r.toneMapping = T.NeutralToneMapping;
    r.domElement.className = 'cf-cv'; r.domElement.setAttribute('aria-hidden', 'true');
    var sc = this.sc = new T.Scene();
    var room = new T.RoomEnvironment(), pm = new T.PMREMGenerator(r); this.envRT = pm.fromScene(room, 0.03); sc.environment = this.envRT.texture; pm.dispose(); if (room.dispose) room.dispose();
    sc.add(new T.AmbientLight(0xffffff, 0.25)); var dl = new T.DirectionalLight(0xffffff, 1.2); dl.position.set(3, 5, 4); sc.add(dl);

    var Ri = 1.6, t = 0.5, N = 48;
    var inner = function (y) { return domed ? Ri + 0.26 - 0.26 * Math.sqrt(Math.max(0, Math.cos(Math.PI * y))) : Ri; };
    var pts = [], i, y;
    for (i = 0; i <= N; i++) { y = -0.5 + i / N; pts.push(new T.Vector2(Ri + t * 0.55 + t * 0.45 * Math.sqrt(Math.max(0, Math.cos(Math.PI * y))), y)); }
    for (i = N; i >= 0; i--) { y = -0.5 + i / N; pts.push(new T.Vector2(inner(y), y)); }
    var metal = new T.MeshStandardMaterial({ color: new T.Color(col.metal), metalness: 1, roughness: 0.28, side: T.DoubleSide });
    var capM = new T.MeshStandardMaterial({ color: new T.Color(col.profile), roughness: 0.6, side: T.DoubleSide });
    var shape = new T.Shape(pts.map(function (p) { return new T.Vector2(p.x, p.y); }));
    var cap = function (phi) { var m = new T.Mesh(new T.ShapeGeometry(shape), capM); m.rotation.y = phi - Math.PI / 2; return m; };
    var ps = 0.5 * Math.PI, pl = 1.5 * Math.PI;
    var ring = new T.Group();
    ring.add(new T.Mesh(new T.LatheGeometry(pts, 150, ps, pl), metal), cap(ps), cap(ps + pl));
    sc.add(ring);
    /* wedge that gets cut away (gap centred on phi = PI/4, which faces the camera) */
    var wedge = this.wedge = new T.Group();
    var wm = this.wm = metal.clone(); wm.transparent = true;
    wedge.add(new T.Mesh(new T.LatheGeometry(pts, 50, 0, 0.5 * Math.PI), wm));
    sc.add(wedge);
    /* highlight along the inner profile on the cap at phi = 0 (plane x = 0, facing +x) */
    var path = new T.CatmullRomCurve3(Array.from({ length: 41 }, function (_, j) { var yy = -0.5 + j / 40; return new T.Vector3(0.012, yy, inner(yy) - 0.012); }));
    var hl = this.hlM = new T.MeshBasicMaterial({ color: new T.Color(col.highlight), transparent: true, opacity: 0, depthTest: false });
    var tube = new T.Mesh(new T.TubeGeometry(path, 80, 0.03, 8, false), hl); tube.renderOrder = 2; sc.add(tube);
    if (!domed) { /* corner markers on the flat profile */
      [-0.5, 0.5].forEach(function (yy) { var d = new T.Mesh(new T.SphereGeometry(0.05, 16, 12), hl); d.position.set(0.02, yy, Ri); d.renderOrder = 3; sc.add(d); });
    }
    var a = 2.9, asp = W / H;
    this.cam = new T.OrthographicCamera(-a * asp, a * asp, a, -a, 0.1, 50);
  }
  Cut.prototype.frame = function (k) {
    var cut = ease((k - 0.12) / 0.3), zoom = ease((k - 0.5) / 0.38), hl = ease((k - 0.72) / 0.2);
    var dx = Math.SQRT1_2, dz = Math.SQRT1_2;
    this.wedge.position.set(dx * cut * 2.2, cut * 0.6, dz * cut * 2.2);
    this.wedge.rotation.z = -cut * 0.25;
    this.wm.opacity = 1 - cut; this.wedge.visible = cut < 0.999;
    var tgt = [0, lerp(-0.1, -0.12, zoom), lerp(0, 1.85, zoom)];
    var off = [lerp(5, 5.6, zoom), lerp(3.2, 1.1, zoom), lerp(5, 0.9, zoom)];
    this.cam.position.set(tgt[0] + off[0], tgt[1] + off[1], tgt[2] + off[2]);
    this.cam.lookAt(tgt[0], tgt[1], tgt[2]);
    this.cam.zoom = lerp(1, 2.3, zoom); this.cam.updateProjectionMatrix();
    this.hlM.opacity = hl;
    this.r.render(this.sc, this.cam);
  };
  /* Copy what is on the WebGL canvas into a 2D canvas (same task as the render, so no preserveDrawingBuffer needed), then free WebGL. */
  Cut.prototype.freeze = function (slot) {
    var src = this.r.domElement, c = document.createElement('canvas');
    c.width = src.width; c.height = src.height; c.className = 'cf-cv'; c.setAttribute('aria-hidden', 'true');
    try { c.getContext('2d').drawImage(src, 0, 0); slot.replaceChild(c, src); } catch (e) { /* keep the WebGL canvas if the copy fails */ return; }
    this.dispose();
  };
  Cut.prototype.dispose = function () {
    if (this.dead) return; this.dead = true;
    this.sc.traverse(function (o) {
      if (o.geometry) o.geometry.dispose();
      if (o.material) [].concat(o.material).forEach(function (m) { m.dispose(); });
    });
    this.envRT && this.envRT.dispose();
    this.r.dispose(); try { this.r.forceContextLoss(); } catch (e) {}
  };

  function init(root) {
    if (root._cf) return; root._cf = true;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cf-anim]'));
    if (!cards.length) return;
    var mode = root.getAttribute('data-anim') || 'lowend';
    var still = mode === 'off' || mq('(prefers-reduced-motion: reduce)') || window.MES_SLOW === true || (mode === 'lowend' && lowEnd());
    var url = root.getAttribute('data-three'), dur = parseInt(root.getAttribute('data-dur'), 10) || 3600;
    var col = { metal: root.getAttribute('data-metal') || '#b9b9be', profile: root.getAttribute('data-profile') || '#e0793a', highlight: root.getAttribute('data-hl') || '#ffffff' };
    var dpr = Math.min(window.devicePixelRatio || 1, 1.75);

    function mk(T, el) {
      var slot = el.querySelector('[data-cf-slot]'), c = new Cut(T, slot, el.getAttribute('data-domed') === 'true', col, dpr);
      slot.appendChild(c.r.domElement); return { c: c, slot: slot };
    }

    if (still) {
      /* posters only; a card without a poster draws its finished frame once */
      var bare = cards.filter(function (el) { return !el.querySelector('.cf-poster'); });
      if (!bare.length) return;
      var io0 = new IntersectionObserver(function (es) {
        if (!es.some(function (e) { return e.isIntersecting; })) return; io0.disconnect();
        three(url).then(function (T) { bare.forEach(function (el) { var o = mk(T, el); o.c.frame(1); o.c.freeze(o.slot); }); }).catch(function () {});
      }, { rootMargin: '300px 0px' });
      io0.observe(root);
      return;
    }

    var made = null, prepping = false;
    function prep() {
      if (prepping) return; prepping = true;
      three(url).then(function (T) {
        made = cards.map(function (el) {
          var o = mk(T, el); o.el = el; o.c.frame(0);
          var po = el.querySelector('.cf-poster'); if (po) po.classList.add('is-off');
          return o;
        });
        cards.forEach(function (el) { if (el._cfIn) play(el); });
      }).catch(function (e) { prepping = false; if (window.console) console.warn('[mes-cf]', e); });
    }
    function play(el) {
      if (!made || el._cfPlayed) return;
      var o = made.filter(function (x) { return x.el === el; })[0]; if (!o || o.c.dead) return;
      el._cfPlayed = true;
      var t0 = 0;
      var step = function (now) {
        if (!t0) t0 = now;
        var k = Math.min(1, (now - t0) / dur); o.c.frame(k);
        if (k < 1) requestAnimationFrame(step); else o.c.freeze(o.slot);
      };
      requestAnimationFrame(step);
    }
    var ioNear = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { ioNear.disconnect(); prep(); } }, { rootMargin: '300px 0px' });
    ioNear.observe(root);
    var boxes = cards.map(function (el) { return el.querySelector('[data-cf-slot]'); });
    var ioPlay = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.intersectionRatio < 0.6) return;
        var el = cards[boxes.indexOf(e.target)]; if (!el) return;
        el._cfIn = true; ioPlay.unobserve(e.target); play(el);
      });
    }, { threshold: [0, 0.6] });
    boxes.forEach(function (b) { if (b) ioPlay.observe(b); });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-mes-cf]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector && e.target.querySelector('[data-mes-cf]'); if (r) init(r); });
})();
